<template>
  <div style="position:relative" v-loading="loading">
    <div class="search-row">
      <el-input v-model="queryParams.privateThemeName" placeholder="活动名称">
        <i slot="suffix" class="el-input__icon el-icon-search icon-search"></i>
      </el-input>
      <el-select v-model="queryParams.channelCode" clearable placeholder="选择渠道">
        <el-option label="CR餐饮" value="CR"></el-option>
        <el-option label="TT传统渠道" value="TT"></el-option>
        <el-option label="KBKC" value="KBKC"></el-option>
        <el-option label="NL夜店" value="NL"></el-option>
      </el-select>
      <el-select v-model="queryParams.orgCode" clearable placeholder="选择区域">
        <el-option :label="item.orgName" :value="item.orgCode" v-for="item in regionOrgList" :key="item.orgId"></el-option>
      </el-select>
      <!-- 开始时间 -->
      <el-date-picker
        class="date-input"
        v-model="queryParams.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="开始时间"
        :picker-options="pickerOptionsStart"
        @change="checkStartDate"
      />
      <span style="display:inline-block;text-align:center;margin-left:-10px;margin-right:10px;">-</span>
      <!-- 截止时间 -->
      <el-date-picker
        class="date-input"
        v-model="queryParams.endTime"
        type="date"
        placeholder="截止时间"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        @change="checkEndDate"
      />
      <!-- 选择任务类型 -->
      <el-select
        class="reset-taskType"
        v-model="selectTaskType"
        multiple
        clearable
        collapse-tags
        :popper-append-to-body="false"
        placeholder="选择任务类型"
      >
        <el-option v-for="item in taskTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <!-- 选择费用返还方式 -->
      <el-select
        class="reset-feeRefund"
        v-model="selectRefundType"
        multiple
        clearable
        collapse-tags
        :popper-append-to-body="false"
        placeholder="选择费用返还方式"
      >
        <el-option v-for="item in refundTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <el-button class="btn-red" size="small" @click="handleSearch">搜索</el-button>
      <el-button class="btn-reset" size="small" @click="handleReset">重置</el-button>
    </div>
    <div style="display:flex;justify-content:space-between;align-items:center;margin-top: 20px;">
      <div class="tabBoxWrap">
        <div class="tabBox">
          <div class="tabItem" :class="queryParams.themeStatus === 100?'active':''" @click="changeThemeStatus(100)">待审批</div>
          <div class="tabItem" :class="queryParams.themeStatus === 200?'active':''" @click="changeThemeStatus(200)">已生效</div>
        </div>
        <el-switch v-model="queryParams.isSaleBonus" @change="showSaleBonus" />仅查看有交易售点相关活动
      </div>
      <div>
        <el-button v-if="selectShow" type="danger" size="mini" @click="allPass(200)">通过</el-button>
      </div>
    </div>
    <div class="content-list">
      <el-table
        ref="approvalTable"
        :data="configList"
        @selection-change="handleSelectionChange"
        @row-click="toDetail"
        @sort-change="sortChange"
      >
        <el-table-column v-if="selectShow" type="selection" align="center"></el-table-column>
        <el-table-column prop="privateThemeName" label="活动名称" align="center" />
        <el-table-column prop="channel_code" label="渠道" sortable="custom" align="center">
          <template #default="scope">
            <div>{{scope.row.channelName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="org_code" label="区域" sortable="custom" align="center">
          <template #default="scope">
            <div>{{scope.row.orgName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="start_date,end_date" label="活动时间" sortable="custom" align="center">
          <template #default="scope">
            <div>{{scope.row.startDate | parseTime('{y}-{m}-{d}')}}</div>至
            <div>{{scope.row.endDate | parseTime('{y}-{m}-{d}')}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="frequency" label="打卡频次（天/次）" align="center">
          <template #default="scope">
            <div>{{scope.row.execDaysCycle}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="peformTask" label="执行任务" align="center">
          <template #default="scope">
            <div v-for="item in scope.row.taskTypeScopeList" :key="item">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="refundType" label="费用返还方式" align="center" width="200px">
          <template #default="scope">
            <div v-for="(item, index) in getBonusList(scope.row)" :key="index">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="useableBudget" label="可用预算" align="center" width="150px">
          <template #default="scope">
            <!-- <div v-if="scope.row.budgetInfoList">
              <div>{{getBudgetInfoList(scope.row).typeName}}</div>
              <div>{{getBudgetInfoList(scope.row).availableAmount | thousandSymbol}}</div>
            </div>-->
            <div v-if="scope.row.tradeBudgetTypeDTO">
              <div>{{scope.row.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.typeName}}</div>
              <div>{{scope.row.tradeBudgetTypeDTO.trCodeName}}</div>
              <div>{{scope.row.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.availableAmount | thousandSymbol}}</div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="activityStatus" label="活动状态" align="center">
          <template #default="scope">
            <div>{{scope.row.themeStatusName}}</div>
          </template>
        </el-table-column>-->
        <el-table-column v-if="showApproval" label="审批" align="center">
          <template #default="scope">
            <span class="rowBtn" @click.stop="allPass(200,scope.row)">通过</span>
            <span class="rowBtn" @click.stop="allPass(0,scope.row)">驳回</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pag-row" v-if="total">
      <el-pagination
        v-if="pageShow"
        background
        layout="total, prev, pager, next"
        :current-page="queryParams.page"
        :page-size="queryParams.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
// import contactVue from '../user/contact.vue'
export default {
  data () {
    return {
      loading: false,
      total: 1,
      input: '',
      value: '',
      switch1: false,
      selectShow: true,
      // showApproval: true,
      configList: [],
      queryParams: {
        privateThemeName: '',
        channelCode: '',
        orgCode: '',
        page: 1,
        pageSize: 5,
        themeStatus: 100,
        taskTypeScope: '',
        bonusTypeScope: '',
        startTime: '', // 开始时间
        endTime: '', // 截止时间
        isSaleBonus: false, // 仅查看有交易售点活动
        themeMethod: '', // 排序方式
        themeCol: '' // 排序字段
      },
      allPassList: [], // 批量审批活动
      regionOrgList: [],
      pageShow: false,
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      taskTypeList: [], // 任务类型列表
      refundTypeList: [], // 费用返还方式列表
      selectTaskType: [], // 选中的任务类型
      selectRefundType: [] // 选中的费用返还方式
    }
  },
  computed: {
    showSelect () {
      return this.queryParams.themeStatus === 100
    },
    // 控制table两列或以上显示不显示时，不能用同一个boolean变量，会导致控制失效，必须使用
    // 分开来不同的boolean变量对应 不同的列
    showApproval () {
      return this.queryParams.themeStatus === 100
    }
  },
  beforeRouteEnter (to, from, next) {
    // console.log(to, from, next)
    next(vm => {
      if (from.name === 'perfect-region-detail') {
        vm.queryParams = JSON.parse(sessionStorage.getItem('approveParams'))
      }
    })
  },
  mounted () {
    this.getApprovalList()
    this.getRegionOrgList()
    // 获取任务类型列表
    this.getTaskTypeList()
    // 获取费用返还方式
    this.getRefundTypeList()
    this.$nextTick(() => {
      this.selectShow = this.queryParams.selectShow ?? true
    })
  },
  methods: {
    // 获取活动配置列表
    getApprovalList () {
      this.loading = true
      this.queryParams.taskTypeScope = this.selectTaskType.join(',')
      this.queryParams.bonusTypeScope = this.selectRefundType.join(',')
      // console.log(this.queryParams)
      tradeApi.getApprovalList(this.queryParams).then(res => {
        if (res.data.resultCode === '0') {
          this.loading = false
          this.configList = res.data.resultData.tradePerfectThemeDefineList
          this.total = res.data.resultData.pageInfo.totalCounts
          this.$nextTick(() => {
            this.pageShow = true
          })
        }
      })
    },
    // 开始时间选择器
    checkStartDate: function (value) {
      // let _this = this
      this.pickerOptionsEnd = {
        disabledDate: time => {
          // console.log(this)
          let startTime = this.queryParams.startTime
          // 截止时间不能小于开始时间
          if (startTime) {
            return time.getTime() <= new Date(startTime).getTime() - 86400000
          }
        }
      }
    },
    // 截止时间选择器
    checkEndDate: function (value) {
      this.pickerOptionsStart = {
        disabledDate: (time) => {
          let endTime = this.queryParams.endTime
          // 开始时间不能大于截止时间
          if (endTime) {
            return time.getTime() >= new Date(endTime).getTime()
          }
        }
      }
    },
    // 仅查看有交易售点相关活动
    showSaleBonus () {
      this.queryParams.page = 1
      this.getApprovalList()
    },
    // 排序
    sortChange (val) {
      this.queryParams.page = 1
      // 可以获取{column,prop,order}数据
      // console.log(val)
      this.queryParams.themeMethod = val.order === 'ascending' ? 'asc' : val.order === 'descending' ? 'desc' : ''
      if (val.prop === 'start_date,end_date') {
        let arr = val.prop.split(',')
        if (this.queryParams.themeMethod !== '') {
          arr[0] = arr[0] + ' ' + this.queryParams.themeMethod
        }
        this.queryParams.themeCol = arr.join(',')
      } else {
        this.queryParams.themeCol = val.prop
      }
      this.getApprovalList()
    },
    // 预算池信息
    getBudgetInfoList (val) {
      let budgetInfo = {}
      val.budgetInfoList.forEach(item => {
        if (item.typeId === val.budgetTypeId) {
          budgetInfo = item
        }
      })
      return budgetInfo
    },
    changeThemeStatus (status) {
      this.queryParams.page = 1
      this.queryParams.themeStatus = status
      this.getApprovalList()

      this.$nextTick(() => {
        this.selectShow = status !== 200
        // this.showApproval = status !== 200
      })
    },
    handleSelectionChange (val) {
      this.allPassList = val.map(item => {
        return { themeDefineId: item.themeDefineId, themeStatus: 200 }
      })
    },
    // 搜索
    handleSearch () {
      this.queryParams.page = 1
      this.getApprovalList()
    },
    // 重置
    handleReset () {
      this.queryParams = this.$options.data().queryParams
      this.selectTaskType = []
      this.selectRefundType = []
      this.getApprovalList()
    },
    // region 区域列表
    getRegionOrgList () {
      tradeApi.getRegionOrgList().then(res => {
        if (res.data.resultCode === '0') {
          this.regionOrgList = res.data.resultData.regionList
          if (this.regionOrgList.length === 1) {
            this.queryParams.orgCode = this.regionOrgList[0].orgCode
          }
        }
      })
    },
    // 获取任务类型列表
    getTaskTypeList () {
      let params = {
        name: 'tradeTaskTypeMap'
      }
      tradeApi.getTaskTypeList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.taskTypeList = res.data.resultData.tradeTaskTypeMap
        }
      })
    },
    // 获取费用返还方式列表
    getRefundTypeList () {
      let params = {
        name: 'tradeBonusTypeMap'
      }
      tradeApi.getRefundTypeList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.refundTypeList = res.data.resultData.tradeBonusTypeMap
        }
      })
    },
    // 分页器
    handleCurrentChange (val) {
      this.queryParams.page = val
      this.getApprovalList()
    },
    toDetail (row, col, e) {
      // console.log(row)
      // console.log(col)
      // console.log(e)
      this.$router.push({ name: 'perfect-region-detail', query: { themeDefineId: row.themeDefineId } })
      this.queryParams.selectShow = this.selectShow
      sessionStorage.setItem('approveParams', JSON.stringify(this.queryParams))
    },
    allPass (themeStatus, row) {
      if (!row && this.allPassList.length === 0) {
        this.$message.warning('请勾选需通过活动')
        return
      }
      let params = row ? [{ themeDefineId: row.themeDefineId, themeStatus }] : this.allPassList
      // let mag = themeStatus === 200 ? '审批通过' : '驳回'
      // if (!row) {
      //   mag = '批量通过已勾选'
      // }
      // 注：inputPattern属性无法用变量表示无匹配规则，故if，else判断
      if (themeStatus === 200) {
        this.$prompt('请输入审批通过原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          params.map(item => {
            item.processRemark = value
            return item
          })
          tradeApi.perfectApproval(params).then(res => {
            if (res.data.resultCode === '0') {
              // this.getApprovalList()
              this.$message.success('审批通过成功')
              this.getApprovalList()
              this.$emit('handleRefresh')
            }
          })
        }).catch(() => { })
      } else {
        this.$prompt('请输入审批驳回原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '请输入审批驳回原因'
        }).then(({ value }) => {
          params.map(item => {
            item.processRemark = value
            return item
          })
          tradeApi.perfectApproval(params).then(res => {
            if (res.data.resultCode === '0') {
              // this.getApprovalList()
              this.$message.success('驳回成功')
              this.getApprovalList()
              this.$emit('handleRefresh')
            }
          })
        }).catch(() => { })
      }
    },
    // 返还方式数据组合
    getBonusList (data) {
      if (!data.bonusTypeNameScope) {
        return []
      }
      let list = data.bonusTypeNameScope.split(',')
      return list
    }
    // list = list.map(item => {
    //   item = { key: item }
    //   // if (item.key === '线上现金返还' || item.key === '线下现金返还') {
    //   //   if (data.bonusFeeChooseType === '01') {
    //   //     item.value = data.bonusFeeMin + '-' + data.bonusFeeMax + '元/周'
    //   //   } else {
    //   //     item.value = data.bonusFeeScope + '元/周'
    //   //   }
    //   // } else {
    //   //   if (data.bonusBeerChooseType === '01') {
    //   //     item.value = data.bonusBeerMin + '-' + data.bonusBeerMax + '箱/周'
    //   //   } else {
    //   //     item.value = data.bonusBeerQtyScope + '箱/周'
    //   //   }
    //   // }
    //   return item
    // })

  }
}
</script>

<style lang="scss" scoped>
.search-row {
  // display: flex;
  .el-input {
    width: 170px;
    margin-right: 20px;
    margin-bottom: 15px;
  }
  .el-select {
    width: 170px;
    margin-right: 20px;
    margin-bottom: 15px;
  }
  .icon-search {
    line-height: 39px !important;
  }
  .reset-taskType {
    width: 170px !important;
  }
  .reset-feeRefund {
    width: 240px !important;
  }
  .date-input {
    width: 170px !important;
    ::v-deep .el-input__icon {
      line-height: 36px !important;
    }
  }
}
// .btn-box {
//   margin-top: 20px;
//   text-align: right;
// }
.tabBoxWrap {
  display: flex;
  align-items: center;
  .el-switch {
    line-height: 36px;
    margin: 0 10px 0 40px;
  }
  .tabBox {
    cursor: pointer;
    display: flex;
    align-items: center;
    background-color: #fff;
    width: 200px;
    // margin-top: 20px;
    .active {
      font-weight: bold;
      color: #cd1231;
      border-bottom: 1px solid #cd1231;
    }
    .tabItem {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
  }
}
.rowBtn {
  cursor: pointer;
  color: #409dfe;
  margin: 0 5px;
}
.handle-box {
  position: absolute;
  right: 0;
  top: 0;
}
.btn-reset {
  background-color: #bbb;
  color: #ffffff;
}
.content-list {
  ::v-deep .el-table .cell {
    line-height: 19px;
    font-size: 14px;
  }
  margin-top: 30px;
  .el-dropdown-link {
    color: #409dfe;
    cursor: pointer;
  }
}
.dropdown {
  width: 100%;
  height: 60px;
  span {
    display: block;
    height: 100%;
    width: 100%;
    line-height: 60px;
  }
}
.el-dropdown-menu__item {
  padding: 0;
  div {
    width: 70px;
    text-align: center;
  }
}
</style>
